import React from 'react';
import {
    Card,
    FormLayout,
    Checkbox,
    Select,
    Button
} from '@shopify/polaris';
import { KeywordTagMappingEntry } from '../KeywordTagMappingEntry';

export function TagProductsByKeywordsSettings(props) {

    function handleFieldsChange(value) {

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.fields = value;
        props.onSettingsChange(newSettings);
    }


    function handleAutoRemoveTagsChange(value) {

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.autoRemoveTags = value;
        props.onSettingsChange(newSettings);
    }

    function handleMappingDelete(index) {

        const newMappings = [
            ...props.settings.mappings.slice(0, index),
            ...props.settings.mappings.slice(index + 1),
        ]

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.mappings = newMappings;
        props.onSettingsChange(newSettings);
    }

    function handleValueMappingUpdate(index, keyword, tag, matchWholeWord, ruleFields) {

        const newMappings = [
            ...props.settings.mappings.slice(0, index),
            {
                keyword: keyword,
                tag: tag,
                matchWholeWord: matchWholeWord,
                ruleFields: ruleFields == null || ruleFields === "" ? null : ruleFields
            },
            ...props.settings.mappings.slice(index + 1),
        ]

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.mappings = newMappings;
        props.onSettingsChange(newSettings);
    }

    function handleAddNewMapping() {

        var newMapping = [...props.settings.mappings,
        {
            keyword: "",
            tag: "",
            matchWholeWord: true,
            ruleFields: null
        }
        ];

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.mappings = newMapping;
        props.onSettingsChange(newSettings);
    }

    var mappings = props.settings.mappings.map((item, index) => {
        return <KeywordTagMappingEntry
            key={index}
            index={index}
            keyword={item.keyword}
            tag={item.tag}
            matchWholeWord={item.matchWholeWord}
            ruleFields={item.ruleFields}
            onDelete={handleMappingDelete}
            onUpdate={handleValueMappingUpdate}
        />
    });

    return (
        <React.Fragment>
            <Card.Section>
                <FormLayout>
                    <Select
                        label="Select fields"
                        placeholder='--- Select fields ---'
                        options={[
                            {
                                "label": "Title",
                                "value": "OnlyTitle"
                            },
                            {
                                "label": "Description",
                                "value": "OnlyDescription"
                            },
                            {
                                "label": "Title and Description",
                                "value": "TitleAndDescription"
                            }
                        ]}
                        onChange={handleFieldsChange}
                        value={props.settings.fields}
                        error={props.settingsErrors["fields"]}
                        helpText={
                            <span>
                                Select the fields to search for keywords. You can select Title, Description, or both. Individual mappings can override this setting.
                            </span>
                        }
                    />
                </FormLayout>
            </Card.Section>
            <Card.Section title="Keyword to tag mapping">
                <div>
                    {mappings}
                    <br />
                    <Button plain onClick={handleAddNewMapping}>Add New Mapping</Button>
                </div>
            </Card.Section>
            <Card.Section title="Rule Options">
                <FormLayout>
                    <Checkbox
                        label="Automatically remove tags"
                        checked={props.settings.autoRemoveTags}
                        onChange={handleAutoRemoveTagsChange}
                        helpText={
                            <span>
                                When checked, tags that have been mapped but their corresponding keywords were not found will be removed from the respective product.
                            </span>
                        }
                    />
                </FormLayout>
            </Card.Section>
        </React.Fragment>
    );
}